export enum ResponseStatus {
    COMING = "COMING",
    MAYBE = "MAYBE",
    DECLINED = "DECLINED",
    NOT_SET = "NOT_SET"
}

export interface Respondent {
    fullName: string,
    status?: ResponseStatus,
}

